import InputField from '@common/InputRuleFeild';
import DragAndDropFileComponent from '@common/FileUpload/file-drag-drop';
import { concatString } from '@common/text-helpers';
import { getValue, setValue } from '@utils/lodash';
import React from 'react';
import RichTextEditor from 'react-rte';
import SingleSelectSearchDropdown from '@components/common/CustomSearchableDropdown/SingleSelectSearchDropdown';
import CloseSmallSvgComponent from '@assets/svg-components/close-small';
import Select from 'react-select';
import { useNavigationData } from '@components/common/LeftNavbar/NavigationContext';
import { handleMultiSelectArrayChange } from '@common/handleChange';
import MultiSelectDropdown from '@components/common/CustomSearchableDropdown/multi';

const toolbarConfig: any = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'BLOCK_ALIGNMENT_BUTTONS', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
    {label: 'Italic', style: 'ITALIC'},
    {label: 'Underline', style: 'UNDERLINE'}
  ],
  BLOCK_TYPE_DROPDOWN: [
    {label: 'Normal', style: 'unstyled'},
    {label: 'Heading Large', style: 'header-one'},
    {label: 'Heading Medium', style: 'header-two'},
    {label: 'Heading Small', style: 'header-three'}
  ],
  BLOCK_TYPE_BUTTONS: [
    {label: 'UL', style: 'unordered-list-item'},
    {label: 'OL', style: 'ordered-list-item'}
  ],
  BLOCK_ALIGNMENT_BUTTONS: [
    {label: 'Align Left', style: 'ALIGN_LEFT'},
    {label: 'Align Center', style: 'ALIGN_CENTER'},
    {label: 'Align Right', style: 'ALIGN_RIGHT'},
    {label: 'Align Justify', style: 'ALIGN_JUSTIFY'}
  ]
};

const myBlockStyleFn = (contentBlock: any) => {
  const data = contentBlock.getData();
  const alignment = data.get('textAlign');
  if (alignment) {
    switch (alignment) {
      case 'ALIGN_LEFT':
        return 'text-align--left';
      case 'ALIGN_CENTER':
        return 'text-align--center';
      case 'ALIGN_RIGHT':
        return 'text-align--right';
      case 'ALIGN_JUSTIFY':
        return 'text-align--justify';
      default:
        break;
    }
  }
  return '';
};

function PolicyForm(props: any) {
  const {
    request,
    setRequest,
    simpleValidator,
    handleUploadDocuments,
    handleUploadSelfDecDocuments,
    handleRemoveSelfDecDocuments,
    fileTypes,
  } = props;

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };
  const userData = useNavigationData();
  console.log(userData, 'ooooooooo');

  // Fixed: Better handling of checkbox state
  const handleBackDateCheckbox = (e: any) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setRequest({
        ...request,
        backdate_days_allowed: '', // Start with empty string when checked
      });
    } else {
      // Set to null instead of removing the property for better API handling
      setRequest({
        ...request,
        backdate_days_allowed: null,
      });
    }
  };

  // Fixed: Better handling of number input with null values
  const handleBackDateDays = (e: any) => {
    const value = e.target.value;
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setRequest({
        ...request,
        backdate_days_allowed: value === '' ? '' : parseInt(value, 10),
      });
    }
  };

  // Helper function to determine if back date is enabled
  const isBackDateEnabled = () => {
    const value = request.backdate_days_allowed;
    return value !== undefined && value !== null;
  };

  // Exception Approval Required handlers
  const handleExceptionApprovalCheckbox = (e: any) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setRequest({
        ...request,
        exception_approval_required_days_limit: '', // Start with empty string when checked
      });
    } else {
      // Set to null instead of removing the property for better API handling
      setRequest({
        ...request,
        exception_approval_required_days_limit: null,
      });
    }
  };

  const handleExceptionApprovalDays = (e: any) => {
    const value = e.target.value;
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setRequest({
        ...request,
        exception_approval_required_days_limit:
          value === '' ? '' : parseInt(value, 10),
      });
    }
  };

  // Helper function to determine if exception approval is enabled
  const isExceptionApprovalEnabled = () => {
    const value = request.exception_approval_required_days_limit;
    return value !== undefined && value !== null;
  };

  const handleRemoveUsers = (index: number, id: string) => {
    if (id) {
      let filtered = getValue(request, `policy_admins`, []).map(
        (item: object, i: number) => {
          if (i == index) {
            return {
              ...item,
              action: 'DELETE',
            };
          } else {
            return {
              ...item,
            };
          }
        },
      );
      setValue(request, `policy_admins`, filtered);
      setRequest({ ...request });
    } else {
      let filtered = getValue(request, `policy_admins`, []).filter(
        (_item: object, i: number) => i !== index,
      );
      setValue(request, `policy_admins`, filtered);
      setRequest({ ...request });
    }
  };

  const handleChange = (e: any, index: number, id: string) => {
    setValue(request, `policy_admins[${index}].user`, getValue(e, `id`, ''));
    setValue(request, `policy_admins[${index}].action`, !id ? 'ADD' : 'UPDATE');
    setRequest({ ...request });
  };
  console.log(props, getValue(props, `request`, []), '+++++++++++++');

  const handleAddUser = () => {
    let obj = {
      user: '',
      action: 'ADD',
    };
    getValue(request, `policy_admins`, []).push(obj);
    setRequest({ ...request });
  };

  return (
    <div className="w-50 policy-setting-tabs-content-wrap">
      {/* m-5 w-50 px-3  --- Old Code */}
      {/* w-50 policy-setting-tabs-content-wrap  --- New Code  */}
      <div className="policy-setting-header-text">
        <h6>Policy Settings</h6>
        <p className="sub-text">
          Provide basic policy details, upload travel policy, and configure
          other settings.
        </p>
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label form-label-error">
          Policy Name <span>*</span>
        </label>
        <InputField
          inputType="TEXT"
          placeholder="Enter Policy Name"
          className="form-control w-100"
          name="policy_name"
          id="policy_name"
          value={getValue(request, `policy_name`, '')}
          onChange={(e: any) => handleChangeText(e)}
          label="Policy Name"
          validator={simpleValidator}
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label form-label-error">
          Policy Description <span>*</span>
        </label>
        <InputField
          inputType="TEXTAREA"
          placeholder="Enter Policy Description"
          className="form-control w-100"
          name="description"
          id="description"
          value={getValue(request, `description`, '')}
          onChange={(e: any) => handleChangeText(e)}
          label="Policy Description"
          validator={simpleValidator}
        />
      </div>
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label form-label-error">
          Expense Report Entry Limit <span>*</span>
        </label>

        <Select
          value={
            getValue(props, `request.expense_report_entry_limit`, '') &&
            getValue(props, `request.expense_report_entry_limit`, '') !== 0
              ? {
                  value: getValue(
                    props,
                    `request.expense_report_entry_limit`,
                    '',
                  ).toString(),
                  label: getValue(
                    props,
                    `request.expense_report_entry_limit`,
                    '',
                  ).toString(),
                }
              : null
          }
          onChange={(option: any) =>
            props.setRequest({
              ...props.request,
              expense_report_entry_limit: option.value,
            })
          }
          options={[
            ...Array(
              parseInt(
                userData?.info?.policy?.max_allowed_expense_report_entries ||
                  '10',
              ),
            ),
          ].map((_, index) => ({
            value: (index + 1).toString(),
            label: (index + 1).toString(),
          }))}
          className="basic-single"
          classNamePrefix="select"
          placeholder="Please select"
        />
      </div>

      {/* Fixed: Allow Back Date section with improved checkbox handling */}
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Allow Back Date
        </label>
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            id="allow_back_date"
            onChange={handleBackDateCheckbox}
            checked={isBackDateEnabled()}
            className="me-3"
          />
          <input
            type="text"
            placeholder="Enter number of days"
            className="form-control"
            style={{ width: '200px' }}
            name="backdate_days_allowed"
            id="backdate_days_allowed"
            value={
              isBackDateEnabled() && request.backdate_days_allowed !== ''
                ? request.backdate_days_allowed.toString()
                : ''
            }
            onChange={handleBackDateDays}
            disabled={!isBackDateEnabled()}
          />
        </div>
      </div>

      {/* Exception Approval Required section */}
      <div className="user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Exception Approval Required Limit (in days)
        </label>
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            id="exception_approval_required"
            onChange={handleExceptionApprovalCheckbox}
            checked={isExceptionApprovalEnabled()}
            className="me-3"
          />
          <input
            type="text"
            placeholder="No of days limit for exception approval"
            className="form-control"
            style={{ width: '280px' }}
            name="exception_approval_required_days_limit"
            id="exception_approval_required_days_limit"
            value={
              isExceptionApprovalEnabled() &&
              request.exception_approval_required_days_limit !== ''
                ? request.exception_approval_required_days_limit.toString()
                : ''
            }
            onChange={handleExceptionApprovalDays}
            disabled={!isExceptionApprovalEnabled()}
          />
        </div>
      </div>

      <div className="w-100 user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label form-label-error">
          Default Currency <span>*</span>
        </label>
        <SingleSelectSearchDropdown
          placeholder={`Choose`}
          lookup_api={'default_currency'}
          onChange={(e: any) => {
            setRequest({
              ...request,
              default_currency: getValue(e, `value`, ''),
            });
          }}
          label={`label`}
          //  validator={
          //    getValue(item, `is_mandatory`, false) && simpleValidator
          //  }
          width={'100%'}
          value={getValue(props, `request.default_currency`, '')}
          selectKey={'id'}
          name={'Default Currency'}
          //   mandatory
          // showLabel
        />
      </div>

      <div className="w-100 user-details-wrapper__form-group form-group">
        <label className="checkpoint-active-details__label">
          Paid Through Accounts
        </label>
        <MultiSelectDropdown
          placeholder={`Select`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleMultiSelectArrayChange(
              null,
              e,
              'policy_paid_through_accounts',
              'policy_paid_through_accounts',
              setRequest,
            );
          }}
          label={`label`}
          validator={true}
          width={'100%'}
          name={'Paid Through Accounts'}
          lookup_api={'paid_through_admin'}
          value={getValue(
            props,
            `request.policy_paid_through_accounts`,
            [],
          ).map((item: object) => getValue(item, `id`, ''))}
          lookup_id={getValue(
            props,
            `request.policy_paid_through_accounts`,
            [],
          )}
          mandatory={false}
          // showLabel
        />
      </div>
      <div className="user-details-wrapper__form-group form-group mb-5">
        <label className="checkpoint-active-details__label">
          Policy Document <span></span>
        </label>
        <DragAndDropFileComponent
          uploadFile={handleUploadDocuments}
          name="file"
          types={fileTypes}
          multiple
          classes="bulk-upload_drag-n-drop-wrapper position-absolute"
          fileName={getValue(props, `importedFile.name`, '')}
          setImportTedFile={props.setImportTedFile}
        />
        <div className="mt-3">
          {getValue(props, `documents`, []).map(
            (item: object, index: number) => {
              console.log(item, '---ITEM POLICY FORM---');
              return (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center px-2 mt-2"
                  style={{
                    background: 'rgb(247, 251, 255)',
                    padding: '5px',
                  }}
                >
                  <p>{concatString(getValue(item, `name`, ''), 60)}</p>
                  <div onClick={() => props.handleRemoveDocuments(index)}>
                    <CloseSmallSvgComponent />
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>

      <div className="user-details-wrapper__form-group form-group mb-5">
        <label className="checkpoint-active-details__label">
          Self Declaration Document <span></span>
        </label>
        <DragAndDropFileComponent
          uploadFile={handleUploadSelfDecDocuments}
          name="file"
          types={fileTypes}
          multiple
          classes="bulk-upload_drag-n-drop-wrapper position-absolute"
          fileName={getValue(props, `importedFile.name`, '')}
          setImportTedFile={props.setImportTedFile}
        />
        <div className="mt-3">
          {getValue(props, `selfDeclarationDocuments`, []).map(
            (item: object, index: number) => {
              console.log(item, '---ITEM POLICY FORM---');
              return (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center px-2 mt-2"
                  style={{
                    background: 'rgb(247, 251, 255)',
                    padding: '5px',
                  }}
                >
                  <p>{concatString(getValue(item, `name`, ''), 60)}</p>
                  <div onClick={() => handleRemoveSelfDecDocuments(index)}>
                    <CloseSmallSvgComponent />
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>

      <div className="user-details-wrapper__form-group form-group mb-5">
        <label className="checkpoint-active-details__label">
          Business Expense Guidelines
        </label>
        <RichTextEditor
          value={props.guidelinesEditorState}
          onChange={(value) => props.setGuidelinesEditorState(value)}
          toolbarConfig={toolbarConfig}
          blockStyleFn={myBlockStyleFn}
          className="rte-editor-height"
        />
      </div>

      {/* <div className="w-100">
        <div className="user-details-wrapper__form-group form-group">
          <label className="checkpoint-active-details__label">
            Policy Admin <span></span>
          </label>
          {getValue(request, `policy_admins.length`, 0) > 0 &&
            getValue(request, `policy_admins`, []).map(
              (item: object, index: number) => {
                if (getValue(item, `action`, "") !== "DELETE")
                  return (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <SingleSelectSearchDropdown
                        label={"label"}
                        name="Policy Admin"
                        value={getValue(item, `user`, "")}
                        onChange={(e: any) =>
                          handleChange(e, index, getValue(item, `id`, ""))
                        }
                        placeholder={"Choose Policy Admin"}
                        width={"100%"}
                        validator={simpleValidator}
                        lookup_api={"users"}
                      />
                      <div
                        className="close-image_container ms-3"
                        onClick={() =>
                          handleRemoveUsers(index, getValue(item, `id`, ""))
                        }
                      >
                        <img
                          className="close_image "
                          src={`/images/close-black.svg`}
                        />
                      </div>
                    </div>
                  );
              }
            )}
          <div
            className=" d-flex align-items-center mt-4"
            onClick={() => handleAddUser()}
          >
            <img
              className="custom_field_button_container_image"
              src={`/images/add_circle.svg`}
            />
            <h6 className="header_text_blue ms-2">Add New Policy Admin</h6>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default PolicyForm;
